<template>
  <div class="primary-banner" :class="customClass" :style="{ backgroundColor: bgColor }">
    <div class="primary-banner__main">
      <div class="slogan">
        <slot name="slogan"></slot>
      </div>
      <div v-if="locale === 'zh-CN'" class="divider-desc">
        <template v-for="(desc, i) in descList" :key="desc">
          <a-divider v-if="i !== 0" direction="vertical" />
          <div class="desc-item">{{ desc }}</div>
        </template>
      </div>
      <!-- <TryoutButton class="try-button" /> -->
      <LeadsInline :entry="entry || ''" />
      <div class="pic" :style="{ backgroundImage: `url(${bgImage})` }"></div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
defineProps<{
  bgColor: string;
  bgImage: string;
  descList: string[];
  entry?: string;
  customClass?: string;
}>();
</script>
<style lang="less" scoped>
.primary-banner {
  height: 400px;

  &__main {
    width: 1280px;
    height: 100%;
    position: relative;
    margin: 0 auto;
    padding-top: 60px;

    .pic {
      position: absolute;
      width: 340px;
      height: 340px;
      top: 50%;
      transform: translateY(-50%);
      right: 30px;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .slogan {
      font-weight: 600;
      font-size: 40px;
      line-height: 58px;
      color: #000;
      // width: 610px;
    }

    .divider-desc {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 20px;
      line-height: 38px;
      color: #4e5969;
      margin-top: 20px;
      flex-wrap: wrap;
      // margin-bottom: 96px;

      .desc-item {
        white-space: nowrap;
      }

      :deep(.arco-divider) {
        border-color: #86909c;
      }
    }

    .try-button {
      margin-top: 56px;
    }
  }
}

@media screen and (min-width: 800px) {
  .primary-banner {
    min-width: 1280px;
    padding: 0 32px;
  }
}

@media screen and (max-width: 800px) {
  .primary-banner {
    height: 200px;
    padding-bottom: 30px;
  }

  .primary-banner__main {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .pic {
      display: none;
    }

    .slogan {
      width: 100%;
      text-align: center;
      font-size: 32px;
    }

    .divider-desc {
      flex-wrap: nowrap;

      .desc-item {
        font-size: 15px;
        line-height: 32px;
      }
    }

    .try-button {
      margin-top: 28px;
      width: 136px;
      height: 42px;
      font-size: 16px;

      :deep(.icon) {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
